import { User, UserAPI } from './user';

export class Role {
  id: number;
  slug: string;
  name: string;

  constructor(id: number, slug: string, name: string) {
    this.id = id;
    this.slug = slug;
    this.name = name;
  }

  static factory(roleAPI: RoleAPI): Role {
    return new Role(roleAPI.id, roleAPI.slug, roleAPI.name);
  }
}

export type RoleAPI = {
  id: number;
  slug: string;
  name: string;
};

export class RoleList {
  list: Role[];
  total: number;
  currentPage?: number;
  lastPage?: number;
  perPage?: number;
  from?: number;
  to?: number;

  constructor(
    list: Role[],
    total: number,
    currentPage?: number,
    lastPage?: number,
    perPage?: number,
    from?: number,
    to?: number,
  ) {
    this.list = list;
    this.total = total;
    this.currentPage = currentPage;
    this.lastPage = lastPage;
    this.perPage = perPage;
    this.from = from;
    this.to = to;
  }

  static factory(roleListAPI: RoleListAPI): RoleList {
    return new RoleList(
      roleListAPI.data.map((role: RoleAPI) => Role.factory(role)),
      roleListAPI.total,
      roleListAPI.current_page,
      roleListAPI.last_page,
      roleListAPI.per_page,
      roleListAPI.from,
      roleListAPI.to,
    );
  }
}

export type RoleListAPI = {
  data: RoleAPI[];
  total: number;
  current_page?: number;
  last_page?: number;
  per_page?: number;
  from?: number;
  to?: number;
};
